import React from 'react';
import { Marker } from '@react-google-maps/api';
import { LocationCoords } from '../../types/fare';

interface CustomMarkersProps {
  pickup: LocationCoords | null;
  destination: LocationCoords | null;
}

export default function CustomMarkers({ pickup, destination }: CustomMarkersProps) {
  const pickupIcon = {
    url: "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3e%3cpath d='M20 5 C14.5 5 10 9.5 10 15 C10 21 20 35 20 35 S30 21 30 15 C30 9.5 25.5 5 20 5 Z' fill='%2310b981' stroke='white' stroke-width='2.5'/%3e%3ccircle cx='20' cy='15' r='4' fill='white'/%3e%3c/svg%3e",
    scaledSize: new google.maps.Size(40, 40),
    anchor: new google.maps.Point(20, 35),
  };

  const destinationIcon = {
    url: "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3e%3cpath d='M20 5 C14.5 5 10 9.5 10 15 C10 21 20 35 20 35 S30 21 30 15 C30 9.5 25.5 5 20 5 Z' fill='%23ef4444' stroke='white' stroke-width='2.5'/%3e%3ccircle cx='20' cy='15' r='4' fill='white'/%3e%3c/svg%3e",
    scaledSize: new google.maps.Size(40, 40),
    anchor: new google.maps.Point(20, 35),
  };

  return (
    <>
      {/* Pickup marker - Green */}
      {pickup && (
        <Marker
          position={{ lat: pickup.lat, lng: pickup.lng }}
          icon={pickupIcon}
          title="Pickup Location"
        />
      )}

      {/* Destination marker - Red */}
      {destination && (
        <Marker
          position={{ lat: destination.lat, lng: destination.lng }}
          icon={destinationIcon}
          title="Destination"
        />
      )}
    </>
  );
}

